import { networkRequest, AppAsyncAction } from './helpers';

export function health(): AppAsyncAction {
  return async (dispatch) => {
    await dispatch(networkRequest('/health', 'GET'));
  };
}
